import { observer } from "mobx-react";
import _ from "lodash";
import ProductListing from "./product-listing";
import { Button } from "react-bootstrap";
import { useEffect, useState } from "react";
import ProductForm from "./product-form";
import { useStores } from "../../stores/root-store";
import ProductAddOnForm from "./addons-form";
import { faPlus } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

const ManageProducts = observer(() => {
  const { productStore } = useStores();
  const { editProduct, setEditProduct, isAddOnsRequest } = productStore;
  const [showProductForm, setShowProductForm] = useState(false);
  const [showAddOnsForm, setShowAddOnsForm] = useState(false);

  const handleProductFormClose = (show: boolean) => {
    setShowProductForm(show);
    if (!show) setEditProduct(null, false);
  };

  const handleAddOnsFormClose = (show: boolean) => {
    setShowAddOnsForm(show);
    if (!show) setEditProduct(null, false);
  };

  useEffect(() => {
    setShowProductForm(editProduct != null && !isAddOnsRequest);
    setShowAddOnsForm(editProduct != null && isAddOnsRequest);
  }, [editProduct, isAddOnsRequest]);

  return (
    <div className="mt-3">
      <div className="row me-2 ms-2 mb-2">
        <h4 className="mb-0 text-start">
          <span>Products</span>

          <Button
            onClick={() => setShowProductForm(true)}
            className="btn-default float-end"
          >
            <FontAwesomeIcon icon={faPlus} className="me-2" />
            New Product
          </Button>
        </h4>
      </div>
      <ProductListing />
      {showProductForm && (
        <ProductForm
          show={showProductForm}
          setShowModal={handleProductFormClose}
        />
      )}
      {showAddOnsForm && (
        <ProductAddOnForm
          show={showAddOnsForm}
          setShowModal={handleAddOnsFormClose}
        />
      )}
    </div>
  );
});

export default ManageProducts;
